export const DELIVERY_INDEX_STATUS = {
  OPEN: 'open',
  DELIVERY_RECEIPT: 'delivery_receipt',
  PRE_SALE: 'pre_sale',
  PRESALE_REFUND: 'presale_refund',
  REFUND: 'refund',
  PARTIAL: 'partial',
  PARTIAL_DELIVERY_RECEIPT: 'partial_delivery_receipt',
  PARTIAL_REFUND: 'partial_refund',
  CANCELLED: 'cancelled',
  TO_BE_ASSIGNED: 'to_be_assigned',
  PROCESSING: 'processing',
  SENT: 'sent',
  RECEIVED: 'received'
}

export const DELIVERY_INDEX_STATUS_GROUPS = {
  DELIVERED: [DELIVERY_INDEX_STATUS.DELIVERY_RECEIPT, DELIVERY_INDEX_STATUS.PRE_SALE],
  PARTIAL: [
    DELIVERY_INDEX_STATUS.PARTIAL_DELIVERY_RECEIPT,
    DELIVERY_INDEX_STATUS.PARTIAL_REFUND
  ],
  REFUNDED: [
    DELIVERY_INDEX_STATUS.REFUND,
    DELIVERY_INDEX_STATUS.PRESALE_REFUND,
  ],
  DELIVERY_DETAIL: [
    DELIVERY_INDEX_STATUS.DELIVERY_RECEIPT,
    DELIVERY_INDEX_STATUS.PARTIAL_DELIVERY_RECEIPT,
    DELIVERY_INDEX_STATUS.PRE_SALE
  ]
}

export const STATUS_OPTIONS = [
  { name: 'POR ENTREGAR', value: DELIVERY_INDEX_STATUS.OPEN },
  { name: 'ENTREGADO', value: DELIVERY_INDEX_STATUS.DELIVERY_RECEIPT },
  { name: 'RECHAZADO', value: DELIVERY_INDEX_STATUS.REFUND },
  { name: 'PARCIAL', value: DELIVERY_INDEX_STATUS.PARTIAL },
  { name: 'ANULADO', value: DELIVERY_INDEX_STATUS.CANCELLED }
]

export const DATE_PICKER_SETTINGS = {
  months: [
    ['Enero', 'Ene'],
    ['Febrero', 'Feb'],
    ['Marzo', 'Mar'],
    ['Abril', 'Abr'],
    ['Mayo', 'May'],
    ['Junio', 'Jun'],
    ['Julio', 'Jul'],
    ['Agosto', 'Ago'],
    ['Septiembre', 'Sep'],
    ['Octubre', 'Oct'],
    ['Noviembre', 'Nov'],
    ['Diciembre', 'Dic']
  ],
  weekDays: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
  weekStartDayIndex: 1
}

export const ASSIGN_STATUS_TYPES_DIC = {
  OPEN: DELIVERY_INDEX_STATUS.OPEN,
  TO_BE_ASSIGNED: DELIVERY_INDEX_STATUS.TO_BE_ASSIGNED,
  PROCESSING: DELIVERY_INDEX_STATUS.PROCESSING
}


export const ON_BOARD_SALE = {
  key: 'on_board_sale',
  name: 'Venta a bordo',
  shortName: 'Venta a bordo',
  description: 'Venta a Bordo',
  downloadName: 'VentaABordo'
}

export const DELIVERY_STATUS_DIC = {
  [DELIVERY_INDEX_STATUS.OPEN]: { label: 'POR ENTREGAR', className: 'delivery-open-style' },
  [DELIVERY_INDEX_STATUS.TO_BE_ASSIGNED]: {
    label: 'POR ASIGNAR',
    className: 'cancelled-style'
  },
  [DELIVERY_INDEX_STATUS.SENT]: { label: 'ENVIADO', className: 'delivery-sent-style' },
  [DELIVERY_INDEX_STATUS.DELIVERY_RECEIPT]: {
    label: 'ENTREGADO',
    className: 'delivery-received-style'
  },
  [DELIVERY_INDEX_STATUS.PRE_SALE]: {
    label: 'ENTREGADO',
    className: 'delivery-received-style'
  },
  [DELIVERY_INDEX_STATUS.PARTIAL_DELIVERY_RECEIPT]: {
    label: 'PARCIAL',
    className: 'delivery-received-style'
  },
  [DELIVERY_INDEX_STATUS.PARTIAL_REFUND]: {
    label: 'PARCIAL',
    className: 'delivery-received-style'
  },
  [DELIVERY_INDEX_STATUS.REFUND]: {
    label: 'RECHAZADO',
    className: 'delivery-received-style'
  },
  [DELIVERY_INDEX_STATUS.PRESALE_REFUND]: {
    label: 'RECHAZADO',
    className: 'delivery-received-style'
  },

  [DELIVERY_INDEX_STATUS.RECEIVED]: {
    label: 'RECIBIDO',
    className: 'delivery-received-style'
  },
  [DELIVERY_INDEX_STATUS.CANCELLED]: { label: 'ANULADO', className: 'cancelled-style' }
}

export const DELIVERY_TYPES_UI = {
  normal: { name: 'Entrega', shortName: 'Entrega' },
  on_board_sale: { name: ON_BOARD_SALE.name, shortName: ON_BOARD_SALE.shortName }
}
